import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import {RoadSegment} from "../../../../integration/representation/road-segment";
import LocationalState from "../LocationalState";

interface TagProps {
}

interface DispatchProps {
}

interface StateProps {
    selectedRoadSegment: RoadSegment,
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        selectedRoadSegment: selectors.selectedRoadSegment(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
});

class Component extends React.Component<Props, {}> {

    render(){
        const {selectedRoadSegment} = this.props;

        if (!selectedRoadSegment){
            return (
                <h4>Ingen veg er valgt</h4>
            )
        }

        return (
                <h4>Veg: {selectedRoadSegment.roadRef}</h4>
        );
    }
}

export const RoadSegmentInfo = connect(mapStateToProps, mapDispatchToProps)(Component);